import { apiBase } from '@/api/instance';
import Qs from 'qs';

export const SearchFeed = (params) => {
  return apiBase({
    url: `/cats/feeds`,
    method: 'get',
    params: params,
    paramsSerializer: (params) => {
      return Qs.stringify(params, { arrayFormat: 'repeat' });
    }
  });
};

export const StoreFeed = (params) => {
  return apiBase({
    url: '/cats/feeds',
    method: 'post',
    data: params
  });
};

export const ShowFeed = ({ id }) => {
  return apiBase({
    url: `/cats/feeds/${id}`,
    method: 'get'
  });
};

export const UpdateFeed = (params) => {
  return apiBase({
    url: `/cats/feeds/${params.id}`,
    method: 'put',
    data: params
  });
};

export const DestroyFeed = ({ id }) => {
  return apiBase({
    url: `/cats/feeds/${id}`,
    method: 'delete'
  });
};
